import {CSSProperties} from "react";

export const MIN_PINCH_ZOOM_SCALE = 1;
export const MAX_PINCH_ZOOM_SCALE = 4;
export const DOUBLE_TAP_ZOOM_SCALE = 2;
export const DOUBLE_TAP_MAX_MS = 300;
export const DOUBLE_TAP_MAX_PX = 30;
export const SNAP_BACK_MAX_SCALE = 1.05;

export interface IDoubleTapState {
    lastTapTime: number;
    lastTapX: number;
    lastTapY: number;
}

export interface IClampPinchTranslateParams {
    containerWidth: number;
    containerHeight: number;
    scale: number;
    x: number;
    y: number;
}

export interface IShouldSnapBackScaleParams {
    scale: number;
    minScale?: number;
    snapBackMaxScale?: number;
}

export interface IIsDoubleTapParams {
    now: number;
    tapX: number;
    tapY: number;
    state: IDoubleTapState;
    maxMs?: number;
    maxPx?: number;
}

export interface IGetPinchZoomImageStyleParams {
    scale: number;
    translateX: number;
    translateY: number;
    minScale?: number;
    isGesturing?: boolean;
}

export const clampPinchTranslate = ({containerWidth, containerHeight, scale, x, y}: IClampPinchTranslateParams): [number, number] => {
    const maxX = (containerWidth * (scale - 1)) / 2;
    const maxY = (containerHeight * (scale - 1)) / 2;

    return [Math.max(-maxX, Math.min(maxX, x)), Math.max(-maxY, Math.min(maxY, y))];
};

export const getPinchDistance = (dx: number, dy: number) => Math.hypot(dx, dy);

export const shouldSnapBackScale = ({scale, minScale = MIN_PINCH_ZOOM_SCALE, snapBackMaxScale = SNAP_BACK_MAX_SCALE}: IShouldSnapBackScaleParams) =>
    scale > minScale && scale < snapBackMaxScale;

export const isDoubleTap = ({now, tapX, tapY, state, maxMs = DOUBLE_TAP_MAX_MS, maxPx = DOUBLE_TAP_MAX_PX}: IIsDoubleTapParams) => {
    const dTap = getPinchDistance(tapX - state.lastTapX, tapY - state.lastTapY);

    return state.lastTapTime > 0 && now - state.lastTapTime < maxMs && dTap < maxPx;
};

export const getPinchZoomImageStyle = ({
    scale,
    translateX,
    translateY,
    minScale = MIN_PINCH_ZOOM_SCALE,
    isGesturing = false
}: IGetPinchZoomImageStyleParams): CSSProperties => {
    const isZoomed = scale > minScale || translateX !== 0 || translateY !== 0;

    return {
        // Always keep an explicit transform so zoom-out can animate (undefined would snap instantly).
        transform: `scale(${scale}) translate(${translateX / scale}px, ${translateY / scale}px)`,
        transformOrigin: "center center",
        // Animate only snap-back to 1×; skip transition during live pan/pinch to stay in sync with fingers.
        transition: isGesturing || scale > minScale ? "none" : "transform 0.2s ease-out",
        willChange: isZoomed ? "transform" : undefined
    };
};
import {CSSProperties} from "react";

export const MIN_PINCH_ZOOM_SCALE = 1;
export const MAX_PINCH_ZOOM_SCALE = 4;
export const DOUBLE_TAP_ZOOM_SCALE = 2;
export const DOUBLE_TAP_MAX_MS = 300;
export const DOUBLE_TAP_MAX_PX = 30;
export const SNAP_BACK_MAX_SCALE = 1.05;

export interface IDoubleTapState {
    lastTapTime: number;
    lastTapX: number;
    lastTapY: number;
}

export interface IClampPinchTranslateParams {
    containerWidth: number;
    containerHeight: number;
    scale: number;
    x: number;
    y: number;
}

export interface IShouldSnapBackScaleParams {
    scale: number;
    minScale?: number;
    snapBackMaxScale?: number;
}

export interface IIsDoubleTapParams {
    now: number;
    tapX: number;
    tapY: number;
    state: IDoubleTapState;
    maxMs?: number;
    maxPx?: number;
}

export interface IGetPinchZoomImageStyleParams {
    scale: number;
    translateX: number;
    translateY: number;
    minScale?: number;
    isGesturing?: boolean;
}

export const clampPinchTranslate = ({containerWidth, containerHeight, scale, x, y}: IClampPinchTranslateParams): [number, number] => {
    const maxX = (containerWidth * (scale - 1)) / 2;
    const maxY = (containerHeight * (scale - 1)) / 2;

    return [Math.max(-maxX, Math.min(maxX, x)), Math.max(-maxY, Math.min(maxY, y))];
};

export const getPinchDistance = (dx: number, dy: number) => Math.hypot(dx, dy);

export const shouldSnapBackScale = ({scale, minScale = MIN_PINCH_ZOOM_SCALE, snapBackMaxScale = SNAP_BACK_MAX_SCALE}: IShouldSnapBackScaleParams) =>
    scale > minScale && scale < snapBackMaxScale;

export const isDoubleTap = ({now, tapX, tapY, state, maxMs = DOUBLE_TAP_MAX_MS, maxPx = DOUBLE_TAP_MAX_PX}: IIsDoubleTapParams) => {
    const dTap = getPinchDistance(tapX - state.lastTapX, tapY - state.lastTapY);

    return state.lastTapTime > 0 && now - state.lastTapTime < maxMs && dTap < maxPx;
};

export const getPinchZoomImageStyle = ({
    scale,
    translateX,
    translateY,
    minScale = MIN_PINCH_ZOOM_SCALE,
    isGesturing = false
}: IGetPinchZoomImageStyleParams): CSSProperties => {
    const isZoomed = scale > minScale || translateX !== 0 || translateY !== 0;

    return {
        // Always keep an explicit transform so zoom-out can animate (undefined would snap instantly).
        transform: `scale(${scale}) translate(${translateX / scale}px, ${translateY / scale}px)`,
        transformOrigin: "center center",
        // Animate only snap-back to 1×; skip transition during live pan/pinch to stay in sync with fingers.
        transition: isGesturing || scale > minScale ? "none" : "transform 0.2s ease-out",
        willChange: isZoomed ? "transform" : undefined
    };
};
